export const version = '2.12.10';
//# sourceMappingURL=version.js.map